import { useFormField } from '@frontend/design-system';
import { ListBoxProvider } from './list-box-context';
import { ListBoxPopoverContainer } from './list-box-popover-container';
import { DefaultViewConfig, PrimaryViewConfig } from './types';

type Props = {
  defaultViewConfig?: DefaultViewConfig;
  primaryViewConfig?: PrimaryViewConfig;
  searchFieldProps?: ReturnType<typeof useFormField<'text'>>;
  onClose: () => void;
};

export const ListBoxPopover = ({ defaultViewConfig, primaryViewConfig, searchFieldProps, onClose }: Props) => {
  return (
    <ListBoxProvider
      defaultViewConfig={defaultViewConfig}
      primaryViewConfig={primaryViewConfig}
      searchFieldProps={searchFieldProps}
      onClose={onClose}
    >
      <ListBoxPopoverContainer />
    </ListBoxProvider>
  );
};
